import { Lightbulb } from "lucide-react";

// What the person's job functions suggest as an access role. An indication only: the role is applied by whoever
// saves the form, under the usual rules (a delegate never gives more rights than they hold); nothing is ever set by itself.
// `currentRole` is the role the account HAS (saved), `selectedRole` the one picked in the form, not saved yet. `assignable`
// (role names the current user may give) and `onUse` are optional: without them the hint is plain text.
export default function SuggestedRoleHint({ suggestions, currentRole, selectedRole, assignable, onUse, note }) {
  if (!suggestions?.length) return null;
  return (
    <div className="flex items-start gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600" data-testid="suggested-role-hint">
      <Lightbulb size={14} className="text-jamora flex-shrink-0 mt-0.5" />
      <div className="min-w-0 space-y-1">
        {suggestions.map((s) => {
          const picked = s.role === selectedRole && s.role !== currentRole;
          const usable = onUse && s.role !== currentRole && !picked && (!assignable || assignable.includes(s.role));
          return (
            <div key={s.role}>
              Ses fonctions ({s.functions.join(", ")}) suggèrent le rôle <strong className="text-slate-900">{s.label}</strong>
              {s.role === currentRole && " (son rôle actuel)"}
              {picked && " (sélectionné, pas encore enregistré)"}.
              {usable && (
                <button type="button" onClick={() => onUse(s.role)} className="ml-1 font-medium text-jamora hover:underline"
                  data-testid={`use-suggested-role-${s.role}`}>
                  Utiliser ce rôle
                </button>
              )}
            </div>
          );
        })}
        {note && <div className="text-slate-500">{note}</div>}
      </div>
    </div>
  );
}
